import { render } from "./CrearPaquete.vue?vue&type=template&id=7b143252&scoped=true"
import script from "./CrearPaquete.vue?vue&type=script&lang=js"
export * from "./CrearPaquete.vue?vue&type=script&lang=js"

import "./CrearPaquete.vue?vue&type=style&index=0&id=7b143252&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b143252"]])

export default __exports__